// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btnSelectHostsCorrelaton{
    height:150%;
    width:95%;
    display:flex;
    justify-content:center;
    align-items:center;
    color:var(--white-color);
    background:var(--third-color) ;
    border-radius: 5px;

}
.btnSelectHostsCorrelaton:hover{
   height:170%;
    width:100%;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/config-components/Correlation/styles/correlation.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,SAAS;IACT,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,kBAAkB;;AAEtB;AACA;GACG,WAAW;IACV,UAAU;IACV,eAAe;AACnB","sourcesContent":[".btnSelectHostsCorrelaton{\r\n    height:150%;\r\n    width:95%;\r\n    display:flex;\r\n    justify-content:center;\r\n    align-items:center;\r\n    color:var(--white-color);\r\n    background:var(--third-color) ;\r\n    border-radius: 5px;\r\n\r\n}\r\n.btnSelectHostsCorrelaton:hover{\r\n   height:170%;\r\n    width:100%;\r\n    cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
